// src/components/shared/MaskedInput.js
import React from 'react';
import styled from 'styled-components';
import InputMask from 'react-input-mask';
import {NumericFormat} from 'react-number-format';

const MaskedInputWrapper = styled.div`
  position: relative;
  margin-bottom: ${(props) => props.theme.spacing(1)};

  svg {
    position: absolute;
    left: 16px;
    top: 50%;
    transform: translateY(-50%);
    font-size: 1.2rem;
    color: ${(props) => props.theme.colors.inputGray};
  }

  label {
    position: absolute;
    top: 5%;
    left: 45px;  /* Padding to align with the input's left padding */
    transform: translateY(-50%);
    background-color: ${(props) => props.theme.colors.surface};  /* Background color to overlap input's border */
    color: ${(props) => props.theme.colors.inputGray};
    font-size: 14px;
    transition: all 0.2s ease;
    padding: 0 5px;  /* Add some padding to prevent label from cutting off */
    pointer-events: none;  /* Prevents the label from being clicked */

  }

  input {
    width: 100%;
    padding: 18px;
    padding-left: 45px;  /* Leave space for the icon */
    margin: 5px 0;
    font-size: 1.2em;
    border: 1px solid ${(props) => props.theme.colors.inputGray};
    border-radius: 5px;
    background-color: ${(props) => props.theme.colors.surface};
    color: ${(props) => props.theme.colors.textPrimary};
    outline: none;

    &:focus {
      border-color: ${(props) => props.theme.colors.textPrimary};
    }

    &:focus + label,
    &:not(:placeholder-shown) + label {
      
      color: ${(props) => props.theme.colors.textPrimary};  /* Change label color when input is focused */
      font-size: 14px;
    }

    &::placeholder {
      color: ${(props) => props.theme.colors.inputGray};
    }
  }
`;

const MaskedInput = ({ label, icon, mask, value, onChange, type, ...props }) => {
  const isCurrency = mask === 'currency';

  return (
    <MaskedInputWrapper>
      {icon}
      {isCurrency ? (
        <NumericFormat
          thousandSeparator={true}
          prefix={'$'}
          decimalScale={4}
          fixedDecimalScale={true}
          value={value}
          onValueChange={({ floatValue }) => onChange({ target: { value: floatValue } })}
          {...props}
        />
      ) : (
        <InputMask
          mask={mask}
          value={value}
          onChange={onChange}
          {...props}
        />
      )}
      <label>{label}</label>
    </MaskedInputWrapper>
  );
};

export default MaskedInput;
